module.exports = __webpack_public_path__ + "static/Juan-Rincon-ade4f652358e67762e4a805387a4c832.png";